export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-prohibited-01f631f392f2d7ec0e2bc3b2d9ed43fc.svg";